import { APIMethod, fetchData } from "@client";

export async function initCompanyPresetsQuery() {
  await fetchData("/preset/init", APIMethod.POST);
}
